import {API_URL, apiPost} from '../api'

export const createCampaign = async data => {
    return await apiPost(API_URL, 'admin/campaign', data)
}
